<template>
  <v-container fluid class="pa-7">
    <v-row>
      <v-col cols="6">
        <v-card
          :color="allItems.length ? 'amber' : 'green'"
          :class="allItems.length ? '' : 'white--text'"
          elevation="2"
        >
          <div class="text-overline px-4 pt-2">{{ $vuetify.lang.t(`$vuetify.searching.toSearch`) }}</div>
          <v-card-title class="pt-0 justify-center">{{ allItems.length }}</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card color="green" dark elevation="2">
          <div class="text-overline px-4 pt-2">{{ $vuetify.lang.t(`$vuetify.searching.searched`) }}</div>
          <v-card-title class="pt-0 justify-center"
            >{{ searchedItems.length }} {{ $vuetify.lang.t(`$vuetify.searching.from`) }} {{ getTotal }}</v-card-title
          >
        </v-card>
      </v-col>
    </v-row>

    <div class="d-flex align-baseline justify-space-between">
      <v-switch v-model="productsSwitch" label="Skrýt nalezené produkty"></v-switch>

      <v-select
        :items="[
          {
            name: 'Vzestupně',
            value: 'ascending',
          },
          {
            name: 'Sestupně',
            value: 'descending',
          },
        ]"
        item-text="name"
        item-value="value"
        label="Řazení"
        dense
        outlined
        class="flex-grow-0"
        v-model="sortedBy"
      ></v-select>
    </div>

    <v-card class="searched_products">
      <v-card-text class="pa-0">
        <div v-for="item in sortedAllItems" :key="item.attributes.id">
          <SearchedProduct
            @change-found="selectItem"
            :type="'select'"
            :itemData="item"
            :productsSwitch="productsSwitch"
          />
        </div>

        <div v-for="item in sortedSearchedItems" :key="item.attributes.id">
          <SearchedProduct
            @change-found="unselectItem"
            :type="'unselect'"
            :itemData="item"
            :productsSwitch="productsSwitch"
          />
        </div>
      </v-card-text>
    </v-card>

    <div
      v-if="!allItems.length && productsSwitch"
      class="d-flex flex-column align-center justify-center search__products-area"
    >
      <p class="search__purple-title">{{ $vuetify.lang.t(`$vuetify.searching.noProducts`) }}</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="200.763"
        height="132.144"
        viewBox="0 0 200.763 132.144"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_79"
              data-name="Rectangle 79"
              width="200"
              height="131.188"
              fill="none"
              stroke="#673ab7"
              stroke-width="1"
            />
          </clipPath>
        </defs>
        <g id="Group_16" data-name="Group 16" transform="translate(0.763 -0.002)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M35.953,729.693,46.7,719.024l35.427,3.289L2.144,763.257Zm.1-.986-.7.693-31.7,31.469v0L.244,764.256l-.015.017L.2,764.3l-.2.763.684-.353,83.651-42.825-37.875-3.518Z"
            transform="translate(-0.001 -633.875)"
            fill="#606060"
            stroke="#673ab7"
            stroke-width="1"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M13.468,687.173l22.8,2.317-35.1,45.443ZM.2,736.173l-.2.763.684-.352.033-.041,2.9-3.75.04-.049v0l1.47-1.9L36.44,690.294l.726-.943.037-.4-.485-.05-23.723-2.412Z"
            transform="translate(0 -605.747)"
            fill="#606060"
            stroke="#673ab7"
            stroke-width="1"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M37.765,718.675l1.116-11.228.037-.4-.485-.05-.453.587L2.88,753.03l-.921,1.194-.015.017.47.415.018-.017,1.426-1.414L37.652,719.8l.015-.134ZM5.368,750.84v0l1.47-1.9L38.155,708.39l-1.089,10.977-.015.141L5.328,750.889Z"
            transform="translate(-1.715 -623.843)"
            fill="#606060"
            stroke="#673ab7"
            stroke-width="1"
          />
          <g id="Group_15" data-name="Group 15" transform="translate(0 0.002)">
            <g id="Group_14" data-name="Group 14" clip-path="url(#clip-path)">
              <path
                id="Path_4"
                data-name="Path 4"
                d="M329.371,741.251a.506.506,0,0,1-.45-.52c.071-2.089.175-3.705.329-5.085a.506.506,0,0,1,.557-.447h0a.505.505,0,0,1,.446.558c-.151,1.354-.254,2.945-.324,5.007a.506.506,0,0,1-.522.488l-.038,0"
                transform="translate(-290.234 -648.726)"
                fill="#606060"
                stroke="#673ab7"
                stroke-width="1"
              />
              <path
                id="Path_5"
                data-name="Path 5"
                d="M353.321,156.483a.506.506,0,0,1-.426-.661l.081-.244a40.781,40.781,0,0,1,4.116-8.82.506.506,0,1,1,.858.536,39.766,39.766,0,0,0-4.013,8.6l-.081.245a.506.506,0,0,1-.534.344m10.468-16.517a.506.506,0,0,1-.281-.88,31.443,31.443,0,0,1,2.785-2.212,33.634,33.634,0,0,1,5.643-3.179.506.506,0,0,1,.413.923,32.617,32.617,0,0,0-5.473,3.082,30.366,30.366,0,0,0-2.695,2.14.5.5,0,0,1-.391.125m17.7-8.338a.506.506,0,0,1-.058-1c1.984-.454,4.115-.858,6.707-1.272q1.533-.245,3.07-.465a.506.506,0,0,1,.144,1q-1.529.22-3.055.463c-2.569.41-4.68.81-6.641,1.259a.5.5,0,0,1-.167.01m19.55-2.954a.506.506,0,0,1,0-1.005c2.883-.317,5.817-.612,8.654-.9l1.19-.12a.506.506,0,0,1,.1,1.006l-1.19.12c-2.835.285-5.767.58-8.645.9a.511.511,0,0,1-.111,0m19.675-2.061a.506.506,0,0,1,0-1c3.645-.422,6.845-.851,9.783-1.31a.506.506,0,1,1,.156,1c-2.951.461-6.165.892-9.823,1.316a.514.514,0,0,1-.113,0m19.524-3.132a.506.506,0,0,1-.055-1c1.937-.432,3.836-.9,5.645-1.4,1.326-.365,2.625-.75,3.861-1.146a.506.506,0,1,1,.308.963c-1.25.4-2.562.789-3.9,1.158-1.825.5-3.741.978-5.694,1.413a.509.509,0,0,1-.165.009M459,117.337a.506.506,0,0,1-.161-.96l.293-.139a90.313,90.313,0,0,0,8.319-4.6.506.506,0,0,1,.528.862,91.312,91.312,0,0,1-8.411,4.651l-.3.142a.5.5,0,0,1-.27.045m17.011-10.069a.506.506,0,0,1-.219-.928c2.293-1.475,5.3-3.423,8.265-5.415a.506.506,0,0,1,.565.839c-2.968,2-5.985,3.949-8.283,5.426a.5.5,0,0,1-.328.077m16.366-11.106a.506.506,0,0,1-.246-.909c2.829-2.091,5.358-4.09,7.732-6.11a.506.506,0,0,1,.655.77c-2.391,2.035-4.938,4.048-7.786,6.153a.5.5,0,0,1-.355.1"
                transform="translate(-311.366 -78.552)"
                fill="#606060"
                stroke="#673ab7"
                stroke-width="1"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M1663.171,4.73a.506.506,0,0,1-.307-.855c1.185-1.216,2.33-2.461,3.405-3.7a.506.506,0,1,1,.763.663c-1.088,1.252-2.246,2.51-3.444,3.74a.505.505,0,0,1-.417.15"
                transform="translate(-1467.156 -0.002)"
                fill="#606060"
                stroke="#673ab7"
                stroke-width="1"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>

    <v-footer fixed class="py-3 px-0 pa-lg-5 primary lighten-5">
      <div class="d-flex justify-space-between w-100">
        <v-btn @click="_redirectToList" class="mx-3" color="grey">
          {{ $vuetify.lang.t(`$vuetify.searching.close`) }}
        </v-btn>

        <v-btn
          @click="saveSearchedItems"
          class="mx-3"
          color="primary"
          :loading="isSaveLoading"
          :disabled="isSaveLoading"
        >
          {{ $vuetify.lang.t(`$vuetify.searching.save`) }}
        </v-btn>
      </div>

      <v-dialog v-model="notAllFound" width="500">
        <v-card>
          <v-card-title class="text-h5 amber mb-5">
            <v-icon color="white" class="mb-1 mr-3"> $vuetify.icons.triangleExclamation </v-icon>
          </v-card-title>

          <v-card-text>
            {{ $vuetify.lang.t(`$vuetify.searching.miss1`) }}
            (<span class="font-weight-bold">{{ this.idsInfo.join(', ').toString() }}</span>)
            {{ $vuetify.lang.t(`$vuetify.searching.miss2`) }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="this.saveAllItems" :loading="isSaveLoading" :disabled="isSaveLoading">
              {{ $vuetify.lang.t(`$vuetify.searching.send`) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-footer>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { orderBy } from 'lodash';

import SearchedProduct from '../../components/search/SearchedProduct.vue';

export default {
  name: 'SearchDetail',

  components: {
    SearchedProduct,
  },

  data() {
    return {
      productsSwitch: true || localStorage.getItem('SwitchStatus'),
      selectedOrders: [],
      searchedItems: [],
      dialog: false,
      notAllFound: false,
      form: [],
      sortedBy: null,
      loadingTimeout: 0,
      idsInfo: [],
      isSaveLoading: false,
    };
  },

  created() {
    this.clearOrderItems();

    this.selectedOrders = JSON.parse(localStorage.getItem('myOrders'));

    this.selectedOrders.forEach(id => this.fetchOrderItems(id));

    this.productsSwitch = JSON.parse(localStorage.getItem('SwitchStatus'));
  },

  watch: {
    productsSwitch: function () {
      localStorage.setItem('SwitchStatus', this.productsSwitch);
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      status: 'orders/getStatus',
      storesStatus: 'stores/getStatus',
      getAllOrders: 'orders/getAllOrders',
      getAllItems: 'orders/getAllItems',
      getTotal: 'orders/getTotal',
    }),

    allItems() {
      return this.getAllItems;
    },

    // if that has a different sku format (DROGERIE-020) than clothes (merch and drugstore), they sort at the end
    sortedAllItems() {
      if (this.sortedBy === 'descending') {
        return [
          ...orderBy(
            this.getAllItems.filter(item => !item.attributes.sku.match(/^[a-zA-Z]/)),
            'attributes.sku',
            'desc'
          ),
          ...this.getAllItems.filter(item => item.attributes.sku.match(/^[a-zA-Z]/)),
        ];
      } else {
        return [
          ...orderBy(
            this.getAllItems.filter(item => !item.attributes.sku.match(/^[a-zA-Z]/)),
            'attributes.sku',
            'asc'
          ),
          ...this.getAllItems.filter(item => item.attributes.sku.match(/^[a-zA-Z]/)),
        ];
      }
    },

    sortedSearchedItems() {
      if (this.sortedBy === 'descending') {
        return [
          ...orderBy(
            this.searchedItems.filter(item => !item.attributes.sku.match(/^[a-zA-Z]/)),
            'attributes.sku',
            'desc'
          ),
          ...this.searchedItems.filter(item => item.attributes.sku.match(/^[a-zA-Z]/)),
        ];
      } else {
        return [
          ...orderBy(
            this.searchedItems.filter(item => !item.attributes.sku.match(/^[a-zA-Z]/)),
            'attributes.sku',
            'asc'
          ),
          ...this.searchedItems.filter(item => item.attributes.sku.match(/^[a-zA-Z]/)),
        ];
      }
    },
  },

  destroyed() {
    this.clearOrderItems();
  },

  methods: {
    ...mapActions({
      fetchOrderItems: 'orders/fetchOrderItems',
      postOrderItems: 'stores/postOrderItems',
      clearOrderItems: 'orders/clearStore',
    }),

    selectItem(index) {
      if (this.productsSwitch) {
        this.loadingTimeout = 2000;
      } else {
        this.loadingTimeout = 0;
      }

      setTimeout(() => {
        this.allItems.forEach(item => {
          if (item.attributes.id === index) {
            this.allItems.splice(this.allItems.indexOf(item), 1);
            this.searchedItems.push(item);
          }
        });
      }, this.loadingTimeout);
    },

    unselectItem(index) {
      this.searchedItems.forEach(item => {
        if (item.attributes.id === index) {
          this.searchedItems.splice(this.searchedItems.indexOf(item), 1);
          this.allItems.push(item);
        }
      });
    },

    saveSearchedItems() {
      this.isSaveLoading = true;

      this.form = [];

      this.searchedItems.forEach(item => {
        this.form.push({
          order_id: item.orderId,
          order_item_id: item.id,
          found: true,
          user_id: this.user.id,
        });
      });

      this.allItems.forEach(item => {
        this.form.push({
          order_id: item.orderId,
          order_item_id: item.id,
          found: false,
          user_id: this.user.id,
        });
      });

      const allIds = [];
      this.idsInfo = [];
      this.form.forEach(item => allIds.push(item.order_id));

      const uniqueIds = allIds.filter((item, index) => allIds.indexOf(item) === index);

      uniqueIds.forEach(id => {
        const items = this.form.filter(item => item.order_id === id);

        const isTrue = items.filter(item => item.found === true);

        this.idsInfo.push(`${id} (${isTrue.length}/${items.length})`);
      });

      if (this.allItems.length > 0) {
        this.notAllFound = true;

        this.isSaveLoading = false;
      } else {
        this.saveAllItems();
      }
    },

    saveAllItems() {
      this.isSaveLoading = true;

      this.postOrderItems({ url: 'orders-searching/finish', formData: this.form }).then(() => {
        if (this.storesStatus === 'success') {
          this.$router.push({ name: 'search', params: { id: this.idsInfo.join(', ').toString() } });
        }
      });
    },

    _redirectToList() {
      this.$router.push({ name: 'search' });
    },
  },
};
</script>

<style>
.search__products-area {
  min-height: calc(100vh - 350px);
}

.search__purple-title {
  color: #673ab7;
  font-size: 1.5rem;
  max-width: 200px;
  text-align: center;
}
</style>
